import { Localization } from '@axl/accel-framework/utils';
import { useInstance } from 'react-ioc';

export function useLoc(): Localization {
    return useInstance(Localization);
}